import { useQuery } from "@apollo/client";
import { graphql } from "@/shared/gql";
import { getPreloadQuery } from "@/shared/gql/apollo-client";
import { SourcingCalendarMatch } from "@/shared/gql/graphql";
import {
  entrySortOf,
  type SourcingEntriesSearch,
} from "@/pages/admin-sourcing-entries/model/search-params";

const FetchSourcingTenderEntries = graphql(`
  query FetchSourcingTenderEntries($input: SearchSourcingTenderEntriesInput!) {
    superAdmin {
      sourcingTenderEntries(input: $input) {
        paginatorInfo {
          total
        }
        data {
          id
          ...SourcingTenderEntryReviewFields
          source
          tenderNedAuthorityName
          website {
            id
            name
            url
          }
        }
      }
    }
  }
`);

export const SOURCING_ENTRIES_PAGE_SIZE = 25;

export const toSourcingEntriesInput = (search: SourcingEntriesSearch) => ({
  search: search.q,
  status: search.status,
  rejectedBy: search.rejectedBy,
  rejectionReason: search.rejectionReason,
  source: search.source,
  missing: search.missing,
  hasSource: search.hasSource,
  tagStatus: search.tagStatus,
  tagConfidence: search.tagConfidence,
  published: search.published,
  calendarMatch: search.possibleDuplicates
    ? SourcingCalendarMatch.PossibleMatch
    : undefined,
  method: search.method,
  year: search.year,
  window: search.window,
  sortBy: entrySortOf(search),
  paginator: {
    page: search.page ?? 1,
    take: SOURCING_ENTRIES_PAGE_SIZE,
  },
});

export const useFetchSourcingTenderEntries = (search: SourcingEntriesSearch) =>
  useQuery(FetchSourcingTenderEntries, {
    variables: { input: toSourcingEntriesInput(search) },
  });

export const preloadSourcingTenderEntries = (search: SourcingEntriesSearch) => {
  getPreloadQuery()(FetchSourcingTenderEntries, {
    variables: { input: toSourcingEntriesInput(search) },
  });
};
